import { useContext } from "react";
import styled from "styled-components";
import { usePostCardContext } from ".";
import { CenterPanelContext } from "../..";
import { FlexColumn } from "../../../../../Common/Styles";
import { Header } from "../1-Header";
import { Topics } from "../2-Topics";
import { Content } from "../3-Content";
import { Footer } from "../4-Footer";

export const DefaultPostCardContentView = () => {
  const { showOriginalPost, originalPostId } = useContext(CenterPanelContext);
  const { isWithinRepostModal, isWithinRepostPost, postId } =
    usePostCardContext();
  const isWithinRepost = isWithinRepostModal || isWithinRepostPost;
  const isOriginalPostShown = showOriginalPost && originalPostId === postId;

  return (
    <Container
      className="post-card"
      $gapInPx={0}
      $hideBoxShadow={isOriginalPostShown || isWithinRepost}
    >
      <Header />
      <Topics />
      <Content />
      {!isWithinRepost && <Footer />}
    </Container>
  );
};

const Container = styled(FlexColumn)<{
  $hideBoxShadow: boolean;
}>(
  ({ theme, $hideBoxShadow }) => `
  background-color: ${theme.Color.elevation.surface["surface-primary"].value};
  border-radius: ${theme.spacing["spacing-2"].value}rem;
  box-shadow: ${$hideBoxShadow ? "none" : theme.boxShadows["box-shadow-m"]};
`
);
